import { computed } from 'vue';
import { useRemoteConfigStore } from '../stores/remoteConfig.store';

/**
 * Kill-switch de envíos programados. Reemplaza al toggle de código
 * `SCHEDULED_TRANSFER_ENTRY_ENABLED`: apagar el feature en producción ahora es
 * un cambio de Remote Config, no un deploy.
 *
 * Gobierna los entrypoints de UI (opción "Programar" del selector de tipo y
 * link "Envíos programados" del menú). Las rutas `/scheduled-transfers` se
 * gatean con `meta.flag` y el guard global `validateFirebaseFeatureFlags`.
 */
export function useScheduledTransfers() {
  const remoteConfigStore = useRemoteConfigStore();
  const config = remoteConfigStore.getFeatureFlag('feature_scheduled_transfers');

  const isEnabled = computed<boolean>(() => config.value.enabled);

  return { isEnabled };
}
